import { useContext } from "react";
import PropTypes from "prop-types";

import { data as en } from "./en/data";
import { data as es } from "./es/data";
import { data as ru } from "./ru/data";
import { data as zh } from "./zh/data";
import { GlobalContext } from "../ContextProvider";

/**
 * Get current language
 * @name GetLang
 * @returns {string}
 */
export const GetLang = () => {
    const { state } = useContext(GlobalContext);
    const { lang } = state || {};

    return lang || "en";
};

/**
 * Translator engine - use context unless a langStr is provided
 * @name T
 * @param {string} key
 * @param {string | null} langStr
 * @returns {string}
 * @constructor
 */
const T = ({ key, langStr }) => {
    let myLang = langStr;
    if (!langStr) {
        myLang = GetLang();
    }

    switch (myLang) {
        case "en":
            if (en[key]) {
                return en[key];
            }
            break;
        case "es":
            if (es[key]) {
                return es[key];
            }
            break;
        case "ru":
            if (ru[key]) {
                return ru[key];
            }
            break;
        case "zh":
            if (zh[key]) {
                return zh[key];
            }
            break;
        default:
            break;
    }

    return en[key] ? en[key] : key;
};

T.propTypes = {
    key: PropTypes.string,
    langStr: PropTypes.string
};

T.defaultProps = {
    key: null,
    langStr: ""
};

export default T;
